<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-1">Acknowledgments</h1>
<p class="para"><span class="dropcap">M</span>any thanks to the kind folk who read chapter drafts, offered thoughtful ideas, and provided general encouragement as this book took shape: Larry Harley, John Gifford, Cindy Honeycutt, Mark Graham, Kent Oehm, Lukas Honeycutt, Paul Pingel, Nancy Tuten, Howard and Tina Pillot, Dan Shonka, Christa Compton, Michael Kohn, Chris Lawrence, Tom Ward, Barbie and Furball White, John Hoffmeyer, Gary Safrit, Josh Kestner, Rachel Connelly, Tony Metze, Pat Riddle, Ed Davis, Jon Heiliger, Doug Sullivan-Gonzalez, Wayne Kannaday, Chris Heavner, and Teddy Carfolite.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Ack.vue?9a829934